import InviteDealerDialogContainer from "./inviteDealerDialog.container";

export default InviteDealerDialogContainer